import { DetailSection } from '@command-center/ui-system';
import type { CascadeContact } from '../lib/leadloop-api';
import { RelatedRecordList } from './record-detail-panels';

/** The confirmed Contact edge for a Call or Form Entry. */
export function LinkedContactRecords({
  contacts,
  loading = false,
}: {
  contacts: CascadeContact[];
  loading?: boolean;
}) {
  return (
    <DetailSection title="Contact">
      <RelatedRecordList
        empty={loading ? 'Loading linked Contact…' : 'No Contact is linked to this record.'}
        items={contacts.map((contact) => ({
          id: contact.id,
          to: `/contacts/${encodeURIComponent(contact.id)}`,
          title: contact.fullName,
          subtitle: [contact.companyName, contact.email, contact.phone].filter(Boolean).join(' · '),
        }))}
      />
    </DetailSection>
  );
}
